export const USER_ACTIONS = {
  'UPDATE_PRACTITIONER': 'USER_UPDATE_PRACTITIONER',
  'REMOVE_PRACTITIONER': 'USER_REMOVE_PRACTITIONER',
  'UPDATE_PATIENT': 'USER_UPDATE_PATIENT',
  'REMOVE_PATIENT': 'USER_REMOVE_PATIENT',
  'CLEAR_PATIENT': 'USER_CLEAR_PATIENT',
  'SET_ORGANIZATION_CONFIGURATION': 'USER_SET_ORGANIZATION_CONFIGURATION',
  'UPDATE_CURRENT': 'USER_UPDATE_CURRENT',
  'INIT_USER_STATE': 'USER_INIT_STATE',
  'SET_CURRENT_USER': 'SET_CURRENT_USER',
  'SET_BROWSER_DETECTED_LANG': 'SET_BROWSER_DETECTED_LANG',
  'SET_RELOAD_ADMIN_WORKLIST': 'SET_RELOAD_ADMIN_WORKLIST',
  'UPDATE_SELECTED_FACILITIES': 'USER_UPDATE_SELECTED_FACILITIES',
  'SET_CURRENT_PATIENT': 'USER_SET_CURRENT_PATIENT',
  'UPDATE_ORGANIZATION_CONFIGURATION_APPLICATIONS': 'USER_UPDATE_ORGANIZATION_CONFIGURATION_APPLICATIONS',
  'SELECTED_FACILITY' : 'SET_SELECTED_FACILITY',
  'SET_CURRENT_PATIENTLINK' : 'CURRENT_PATIENTLINK',
  'SET_CURRENT_PATIENT_IDENTIFIERS' : 'USER_SET_CURRENT_PATIENT_IDENTIFIERS'
};
